import styled from 'styled-components';

const CommentTypo = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;
export const CommentTitle = styled(CommentTypo)`
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 8px;
`;

export const CommentContent = styled(CommentTypo)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
